import { gql } from 'apollo-boost';

export const GET_FOLDER_SHARES = gql`
    query getFolderShares($folderId: ID!) {
        getFolderShares(folderId: $folderId) {
            includeSubfolders
            role
            sharedAt
            lastAccessedAt
            accessCount
            subjectUser {
                id
                email
                fullName
            }
        }
    }
`;
